
import React from "react";

export default function Desktop ({ className, color }){
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 2.25H7C4.381 2.25 2.25 4.381 2.25 7V13C2.25 15.619 4.381 17.75 7 17.75H11.25V20.25H8C7.586 20.25 7.25 20.586 7.25 21C7.25 21.414 7.586 21.75 8 21.75H16C16.414 21.75 16.75 21.414 16.75 21C16.75 20.586 16.414 20.25 16 20.25H12.75V17.75H17C19.619 17.75 21.75 15.619 21.75 13V7C21.75 4.381 19.619 2.25 17 2.25ZM20.25 13C20.25 14.792 18.792 16.25 17 16.25H7C5.208 16.25 3.75 14.792 3.75 13V7C3.75 5.208 5.208 3.75 7 3.75H17C18.792 3.75 20.25 5.208 20.25 7V13Z"
        fill={(color)||"#6F6C99"}
      />
    </svg>
  );
};